module.exports = __webpack_public_path__ + "img/doc2.6a366194.png";